/**
 * keydown → engine への打鍵変換(docs/03_architecture.md §4)。
 *
 * - `window` で直接捕捉して engine に直送する(React を経由しない = 入力遅延50ms要件)
 * - a-z0-9記号は `e.key` を小文字化、スペースは `e.code === 'Space'`
 * - IME・ブラウザショートカットの干渉を避けるため、扱う打鍵は preventDefault する
 */

/** engine に渡す1文字。無視すべきキーなら null。 */
export function keyFromEvent(event: KeyboardEvent): string | null {
  if (event.isComposing || event.keyCode === 229) return null;
  if (event.ctrlKey || event.metaKey || event.altKey) return null;
  if (event.code === 'Space') return ' ';
  const key = event.key;
  if (key.length !== 1) return null;
  return key.toLowerCase();
}

/** ブラウザ既定動作を止めるべきキーか(スクロール・フォーカス移動・IME起動の抑止)。 */
export function shouldPreventDefault(event: KeyboardEvent): boolean {
  if (event.ctrlKey || event.metaKey || event.altKey) return false;
  if (event.code === 'Space' || event.code === 'Tab') return true;
  return event.key.length === 1;
}
